import { render, staticRenderFns } from "./FileThumb.vue?vue&type=template&id=db13100c&"
import script from "./FileThumb.vue?vue&type=script&lang=js&"
export * from "./FileThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports